import React, { Component } from 'react';
import { Alert, Spinner, Card, CardHeader, CardBody, FormFeedback, NavItem, NavLink, Nav, Form, FormGroup, Label, Row, Col, Input, Button } from 'reactstrap';
import _ from 'underscore';
import serialize from 'form-serialize';
import { withRouter } from 'react-router';
import API from '../API';
import { Global } from '~/App';
import { Link } from 'react-router-dom';
import Turnstile from '~/components/Turnstile';

class Reenviar extends Component {
    static displayName = Reenviar.name;

    constructor(props) {
        super(props);
        this.state = {
            errores: [],
            captcha: null,
            cargando: false,
            password: "",
            password2: "",
            correoValido: false
        };
        this.captchaRef = React.createRef();
        this.pendingForm = null;
        this.onCaptchaResolved = this.onCaptchaResolved.bind(this);
        this.onCaptchaError = this.onCaptchaError.bind(this);
    }
    onCaptchaError() {
        this.pendingForm = null;
        this.setState({ cargando: false });
    }
    Reenviar(event) {
        event.preventDefault();
        var form = serialize(event.target, { hash: true });
        if (!form.Mail) {
            this.setState({ errores: ["Debes indicar Correo"] });
            return;
        }
        this.setState({ cargando: true, errores: [] });
        this.pendingForm = form;
        if (this.captchaRef.current) {
            this.captchaRef.current.execute();
        }
    }
    onCaptchaResolved(token) {
        if (!token || !this.pendingForm) return;
        const form = this.pendingForm;
        this.pendingForm = null;
        form.Captcha = token;
        API.Call("Home/ReenviarMailConfirmar", form)
            .then(response => {
                if (this.captchaRef.current) this.captchaRef.current.reset();
                this.setState({ success: response.mensaje, cargando: false });
            })
            .catch(error => {
                if (this.captchaRef.current) this.captchaRef.current.reset();
                this.setState({ errores: [error], cargando: false });
            });
    }
    render() {
        return (
            <Card>
                <CardHeader className="titulo-modal">Reenviar correo de confirmación</CardHeader>
                <CardBody className="cuerpo-modal">
                    {this.state.success ?
                        <div>
                            <Row>
                                <Col sm={{ size: 8, offset: 2 }}>
                                    <Alert color="success">
                                        <h4>{this.state.success}</h4>
                                    </Alert>
                                    <div className="text-sm-right">
                                        <Link to={"/"}>Volver al inicio de sesión</Link>
                                    </div>
                                </Col>
                            </Row>
                        </div> :
                        <Row>
                                    <Col className="bordeCompleto" sm={{ size: 8, offset: 2 }} >
                                        <h4 className="text-muted"><small>No ha podido confirmar su correo?</small></h4>
                                        <h5 className="text-muted"><small>Ingrese su correo y le enviaremos un enlace de confirmación.</small></h5>
                                        <div className="text-sm-right">
                                            <Link to={"/"}>{"Ya tienes cuenta? Inicia Sesión"}</Link>&nbsp;&nbsp;
                                            <Link to={"/recuperar"}>Olvidé mi contraseña</Link>
                                        </div>
                                        <br />
                                        <Form className="text-sm-right" onSubmit={this.Reenviar.bind(this)}>
                                            {_.map(this.state.errores, (e, i) => <Alert key={i} color={"warning"}>{e}</Alert>)}
                                            <FormGroup row>
                                                <Label for="Mail" sm={3}>{"Correo"}</Label>
                                                <Col sm={9}>
                                                    <Input invalid={!this.state.correoValido} onChange={e => this.setState({ correoValido: Global.ValidateEmail(e.target.value) })} bsSize="sm" type="text" name="Mail" />
                                                    <FormFeedback>Debe ser un correo válido</FormFeedback>
                                                </Col>
                                            </FormGroup>
                                            <Turnstile
                                                ref={this.captchaRef}
                                                size="invisible"
                                                sitekey={Global.apiKeyCaptcha}
                                                onChange={this.onCaptchaResolved}
                                                onErrored={this.onCaptchaError}
                                                onExpired={this.onCaptchaError}
                                            />
                                            <Button className="float-right" color="primary" disabled={!this.state.correoValido || this.state.cargando} type="submit">{"Reenviar"}</Button>
                                        </Form>
                                    </Col>
                                </Row>}
                </CardBody>
            </Card>
        );
    }
}

export default withRouter(Reenviar);